import React, { createContext, useState, useEffect } from "react";
import API_URLS from "../summaryapi/apiUrls";

export const AuthContext = createContext();

export const AuthProvider = ({ children, screenId }) => {
  // Decode adminId from sessionStorage using atob
  const [adminId, setAdminId] = useState(
    sessionStorage.getItem("adminId") ? atob(sessionStorage.getItem("adminId")) : null
  );
  const [permissions, setPermissions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  // Decode adminMode from sessionStorage using atob
  const adminMode = sessionStorage.getItem("adminMode") ? atob(sessionStorage.getItem("adminMode")) : null;

  const fetchEmployeeRoles = async (id) => {
    try {
      const response = await fetch(API_URLS.fetchrolesandresponsibilitys.url, {
        method: API_URLS.fetchrolesandresponsibilitys.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ admin_id: id }),
      });
  
      const data = await response.json();
      if (data.status && data.data.length > 0) {
        const mappedPermissions = {};
        data.data.forEach((role) => {
          mappedPermissions[role.screen_id] = {
            is_add: role.is_add === "1",
            is_edit: role.is_edit === "1",
            is_view: role.is_view === "1",
            is_download: role.is_download === "1",
            is_access: role.is_access === "1",
            is_choosefile: role.is_choosefile === "1",
            roles_id: role.roles_id,
          };
        });
        setPermissions(mappedPermissions);
      } else {
        setPermissions({});
      }
    } catch (error) {
      console.error("Error fetching employee roles:", error);
    } finally {
      setIsLoading(false); // Set loading to false after fetching
    }
  };

  useEffect(() => {
    if (adminId && adminMode !== "Admin") {
      fetchEmployeeRoles(adminId);
    } else {
      setIsLoading(false); // If no adminId or adminMode is "Admin", set loading to false
    }
  }, [adminId, adminMode, screenId]);

  return (
    <AuthContext.Provider value={{ permissions, fetchEmployeeRoles, isLoading, adminMode }}>
      {children}
    </AuthContext.Provider>
  );
};